import { PackageVM } from 'src/app/shared/models/interface/concretes/offer-customize-custom.interface';

export type OfferState = {
  selected_offer: string;
  coupon_code: string;
  promotionCode: string;
  sponsor_email: string;
  packages: PackageVM[];
  recommended_package_code: string;
  mensual_price: string;
  highlighted?: boolean;
  reference_devis: string;
  type_promotion: string;
};

export const initialOfferState: OfferState = {
  selected_offer: '',
  coupon_code: '',
  promotionCode: '',
  sponsor_email: '',
  packages: [],
  recommended_package_code: '',
  mensual_price: '',
  highlighted: false,
  reference_devis: '',
  type_promotion: '',
};
